import { AppPerformancePage } from './AppPerformancePage'
import { withAppPerformancePage } from './withAppPerformancePage'

const ConnectedAppPerformancePage = withAppPerformancePage(AppPerformancePage)
export { ConnectedAppPerformancePage as AppPerformancePage }
